import React, { FC, useRef } from 'react';
import { Page } from 'features/document/documentSlice';
import ViewerHeaderSection from './components/ViewerHeaderSection/ViewerHeaderSection';
import ViewerContentSection from './components/ViewerContentSection/ViewerContentSection';
import ViewerFooterSection from './components/ViewerFooterSection/ViewerFooterSection';
import styles from './ViewerPage.module.css';
interface Props {
  content: Page;
  pageNumber: number;
  totalPages: number;
}

const ViewerPage: FC<Props> = ({ content, pageNumber, totalPages }) => {
  const { header, id, isIndividualHeaderVisible, rows, footer, isIndividualFooterVisible } = content;
  const pageRef = useRef<HTMLDivElement>(null);

  return (
    <div id={id} className={styles.page} ref={pageRef}>
      <ViewerHeaderSection header={header} isIndividualHeaderVisible={isIndividualHeaderVisible} />
      <ViewerContentSection rows={rows} />
      <div className={styles.footerPosition}>
        <ViewerFooterSection
          footer={footer}
          isIndividualFooterVisible={isIndividualFooterVisible}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default ViewerPage;
